// React
import React from "react";
// Redux
import { Provider } from "react-redux";
// Components
import AppAgentDesk, { theStore } from "AppAgentDesk";
// This is the lowest level react component.
// It create a redux Provider which enables the state to be injected into the App component.
export class AppInitAgentDesk extends React.Component {
    render() {
        return (React.createElement(Provider, { store: theStore },
            React.createElement(AppAgentDesk, null)));
    }
}
